import {
  AssetRoutine,
  WorkflowRoutineConfig,
  WorkflowRoutineState,
  isNonTerminalIdpStatus,
} from '../domain';
import { useAssetRoutineIdpPoll } from './useAssetRoutineIdpPoll';

/**
 * Whether an IDP-managed submission is still being extracted, from the point
 * of view of a UI affordance that must lock (the revise/edit entry points —
 * plan 0027 Phase 3) rather than a per-field render state (see
 * `workflowMessage.tsx`, which reads the same status for a different
 * purpose). Mirrors that component's poll-gating convention: the live poll
 * only runs while the submitted snapshot itself is non-terminal, so a
 * terminal (or absent) submission never issues a second `getAssetRoutine`
 * fetch.
 */
export const useIsAssetRoutineIdpInProgress = (
  assetRoutine: AssetRoutine | undefined
): boolean => {
  const config = assetRoutine?.routineVersion?.config as
    | WorkflowRoutineConfig
    | undefined;
  const idpEnabled = config?.idpEnabled === true;
  const submittedState = assetRoutine?.data as WorkflowRoutineState | undefined;

  const isSnapshotWaiting =
    idpEnabled && isNonTerminalIdpStatus(submittedState?.idp?.status);
  const { data: polledState } = useAssetRoutineIdpPoll(
    isSnapshotWaiting ? assetRoutine?.id : undefined
  );

  const state = polledState ?? submittedState;

  return idpEnabled && isNonTerminalIdpStatus(state?.idp?.status);
};
